import { render, staticRenderFns } from "./dedicated-search.vue?vue&type=template&id=ab39dca8&"
import script from "./dedicated-search.vue?vue&type=script&lang=js&"
export * from "./dedicated-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports